// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path
                fill="currentColor"
                d="M2.625,3.75 L2.625,1.125 L8.53359389,1.125 L9.375,1.96640611 L9.375,3.75 L10.5,3.75 L10.5,1.5 L9,0 L2.625,0 L1.5,0 L1.5,1.125 L1.5,3.75 L2.625,3.75 Z M9,8.625 L9,10.875 L3,10.875 L3,8.625 L9,8.625 Z M3,7.5 L1.875,7.5 L1.875,8.25 L1.125,8.25 L1.125,5.625 L10.875,5.625 L10.875,8.25 L10.125,8.25 L10.125,7.5 L9,7.5 L3,7.5 Z M10.125,9.375 L10.875,9.375 L12,9.375 L12,8.25 L12,5.625 L12,4.5 L10.875,4.5 L1.125,4.5 L0,4.5 L0,5.625 L0,8.25 L0,9.375 L1.125,9.375 L1.875,9.375 L1.875,10.875 L1.875,12 L3,12 L9,12 L10.125,12 L10.125,10.875 L10.125,9.375 Z"
            />
        </svg>
    );
};

export default React.memo(Print);
